import { useTranslation } from "react-i18next";
import rightIcon from "../../images/icons/right.svg";

const Plans = () => {
  const { t } = useTranslation();

  const plans = [
    {
      name: t("plans.plan1.name"),
      desc: t("plans.plan1.desc"),
      price: t("plans.plan1.price"),
      features: t("plans.plan1.features", { returnObjects: true }) as string[],
    },
    {
      name: t("plans.plan2.name"),
      desc: t("plans.plan2.desc"),
      price: t("plans.plan2.price"),
      features: t("plans.plan2.features", { returnObjects: true }) as string[],
    },
    {
      name: t("plans.plan3.name"),
      desc: t("plans.plan3.desc"),
      price: t("plans.plan3.price"),
      features: t("plans.plan3.features", { returnObjects: true }) as string[],
    },
  ];

  return (
    <section id="plans" className="bg-white">
      <div className="container mx-auto py-24 px-4 flex flex-col items-center">
        <p className="text-center text-4xl md:text-5xl text-main font-bold">
          {t("plans.title")}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-16">
          {plans.map((plan) => (
            <div className="flex flex-col items-center justify-between gap-20 bg-white border border-grayDark first:border-primary rounded-20 px-5 py-10 shadow-15">
              <div className="w-full">
                <p className="text-main">{plan.name}</p>
                <div className="flex items-baseline gap-3 my-4">
                  <p className="text-primary text-xl md:text-4xl font-bold">
                    {plan.price}
                  </p>
                  <p className="text-grayDark text-sm font-light">
                    {t("plans.sar_per_month")}
                  </p>
                </div>
                <p className="text-grayDark text-base">{plan.desc}</p>

                <div className="w-full h-[1px] bg-black/20 my-6"></div>

                <ul className="text-grayDarkness font-normal">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 my-4">
                      <img src={rightIcon} alt="Feature" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              <a
                href="#contactus"
                className="bg-primary text-main w-full text-center py-2 mx-4 rounded-20 transition-all duration-500 ease-out
             hover:-translate-y-1 hover:scale-105 hover:shadow-[0_0_20px_rgba(33,216,104,0.4)] hover:text-white"
              >
                {t("plans.buy_now")}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Plans;
